module.exports = __webpack_public_path__ + "static/media/swap_grey.72d55bca.png";